// extracted by mini-css-extract-plugin
export default {"input":"Input_input__xEyVQ","inputSmall":"Input_inputSmall__pO5Tp"};